import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { Stack } from "@fluentui/react/lib/Stack";

import { ConfirmDialog } from "Components/Actions/ConfirmDialog";
import { DateTimePicker } from "Components/Generic/DateTimePicker";
import { IWithThemeProps } from "Components/Generic/Theme/IWithThemeProps";
import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { EntityType } from "Model/EntityType";
import { getTranslatedFieldLabel } from "Utils/Field";
import { useDatePickerDialogStyles } from "./UseDatePickerDialogStyles";
import { OPERATOR_LIST } from "./Operators";
import { useDatePickerDialog } from "./UseDatePickerDialog";

export const DatePickerDialog = WithTheme(
  WithTranslator((props: IWithTranslatorProps & IWithThemeProps): JSX.Element => {
    const {
      translator,
      theme: { spacing }
    } = props;
    const styles = useDatePickerDialogStyles();

    const {
      errorMessage,
      fieldName,
      isDateTime,
      isDialogHidden,
      onChange,
      onChangeOperator,
      onConfirm,
      onDismiss,
      operator,
      value
    } = useDatePickerDialog();

    if (isDialogHidden) {
      return null;
    }

    return (
      <ConfirmDialog
        hidden={false}
        title={getTranslatedFieldLabel(fieldName, EntityType.Project, translator, fieldName)}
        subText={fieldName}
        confirmButtonText={translator.get(`generic.accept`, `Accept`)}
        onConfirm={onConfirm}
        dismissButtonText={translator.get(`generic.close`, `Close`)}
        onDismiss={onDismiss}
      >
        <Stack horizontal tokens={{ childrenGap: spacing.s2 }}>
          <Stack.Item className={styles.dropdown}>
            <Dropdown options={OPERATOR_LIST} selectedKey={operator} onChange={onChangeOperator} />
          </Stack.Item>
          <Stack.Item grow>
            <DateTimePicker
              errorMessage={errorMessage}
              isDateTime={isDateTime}
              onChange={onChange}
              timePickerProps={{ calloutProps: { calloutMaxHeight: 400 } }}
              value={value}
            />
          </Stack.Item>
        </Stack>
      </ConfirmDialog>
    );
  })
);
